import React, {PropTypes} from 'react';
import {BASE_PATH} from 'shared/variables';
import {Link as ReactRouterLink} from 'react-router';

const Link = props => (
  <ReactRouterLink
    {...props}
    to={`/${BASE_PATH ? `${BASE_PATH}/` : ''}${props.to}`}
  />
);

Link.propTypes = {
  to: PropTypes.string
};

export default Link;



// WEBPACK FOOTER //
// ./src/features/shared/Link.jsx